import React from "react";

const VerifyIcon = ({
  style = {},
  width = "70",
  height = "70",
  className = "",
  fill = "#7758B3",
  stroke = "#7758B3",
  viewBox = "0 0 70 70",
}) => (
  <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#3AAF46"
        fillRule="evenodd"
        d="M16 8A8 8 0 11-.001 8 8 8 0 0116 8zm-3.97-3.03a.75.75 0 00-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 00-1.06 1.06L6.97 11.03a.75.75 0 001.079-.02l3.992-4.99a.75.75 0 00-.01-1.05h-.001z"
        clipRule="evenodd"
      ></path>
    </svg>
   
);

export default VerifyIcon;
